/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const logger = {
    logInfo: (tag: string, message: string) => {
        console.log(`[${tag}] ${message}`);
    }
};